/* assets/dvy-wishlist-inject.js
   Injects the wishlist button into Fabric's native product cards
   (collection grids, search results, related products).
   Custom sections are skipped — they already render the button via Liquid. */
(function () {
  'use strict';

  var MARK = 'data-dvy-injected';

  /* Fabric card selectors, most specific first */
  var CARD_SELECTORS = [
    '.product-card',
    '.card--product',
    '.card-wrapper',
    '.grid__item:has(a[href*="/products/"])'
  ];

  /* Containers that hold product links but are NOT Fabric product cards.
     Cart rows have an <a href="/products/…"> plus a thumbnail; our own
     sections have a product link and a hero image. Both fool the fallback. */
  var SKIP_WITHIN = [
    // our custom sections — button already rendered in Liquid, or not wanted
    '[data-ps-card]', '[data-sw-card]', '[data-wl-card]', '[data-dpx-root]',
    '.section-statement-graphics', '.section-product-showcase',
    '.section-statement-showcase', '.stmt', 'product-showcase',
    'statement-showcase', 'stmt-product',
    '[class*="dvy-"]', '[class*="dpx-"]',
    // cart
    'cart-drawer', 'cart-notification', 'cart-items', 'cart-items-component',
    '#CartDrawer', '#cart-drawer', '[data-cart-drawer]', '.cart-drawer',
    '.drawer--cart', '.cart-item', '.cart__items', '.cart-items',
    'form[action*="/cart"]', '[id*="cart-drawer" i]',
    // search + misc
    'predictive-search', '.predictive-search', '.search-results',
    '.complementary-products', '[data-recently-viewed]',
    // media/editorial sections that link to a product
    '.reel-gallery', '[data-reel]', '.hero', '.banner'
  ].join(',');

  /* The fallback branch only runs inside these — a genuine product listing.
     Running it document-wide made every hero and editorial section with a
     product link sprout a stray heart. */
  var LISTING_ROOTS = [
    '.product-grid',
    '.product-grid-container',
    '[id*="product-grid"]',
    '.collection',
    '.resource-list',
    '.search__results',
    'ul.grid'
  ].join(',');

  var HEART =
    '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
    '<path d="M12 20.3 4.6 13a4.6 4.6 0 1 1 6.5-6.5l.9.9.9-.9A4.6 4.6 0 1 1 19.4 13Z" ' +
    'fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/></svg>';

  function handleFrom(href) {
    if (!href) return '';
    var m = String(href).match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : '';
  }

  function findCards(scope) {
    var out = [];
    var seen = new Set();

    CARD_SELECTORS.forEach(function (sel) {
      var nodes;
      try {
        nodes = scope.querySelectorAll(sel);
      } catch (e) {
        return; // :has() unsupported on older Safari — skip this selector
      }
      Array.prototype.forEach.call(nodes, function (n) {
        if (n.closest(SKIP_WITHIN)) return;
        if (!seen.has(n)) { seen.add(n); out.push(n); }
      });
    });

    if (out.length) return out;

    /* Fallback: no known card class matched. Walk up from each product link,
       but ONLY inside a real listing container. */
    var roots = scope.querySelectorAll(LISTING_ROOTS);
    Array.prototype.forEach.call(roots, function (root) {
      if (root.closest(SKIP_WITHIN)) return;

      var links = root.querySelectorAll('a[href*="/products/"]');
      Array.prototype.forEach.call(links, function (a) {
        if (a.closest(SKIP_WITHIN)) return;

        var node = a;
        for (var i = 0; i < 5 && node.parentElement && node !== root; i++) {
          node = node.parentElement;
          if (node.closest(SKIP_WITHIN)) return;
          if (node.querySelector('img, svg[class*="placeholder"]')) break;
        }
        if (node && node !== document.body && node !== root && !seen.has(node)) {
          seen.add(node);
          out.push(node);
        }
      });
    });

    return out;
  }

  function inject(scope) {
    var root = (scope && scope.querySelectorAll) ? scope : document;

    findCards(root).forEach(function (card) {
      if (card.closest(SKIP_WITHIN)) return;

      /* Guard on the button existing, not on the marker attribute.
         Fabric swaps the media wrapper on hover (slideshow arrows,
         quick-add), destroying anything inside it while the marker
         survives on the card — that left cards permanently heartless. */
      if (card.querySelector('[data-dvy-wishlist-toggle]')) return;

      /* The fallback can return both an outer and an inner wrapper for the
         same product. Injecting into both produces a double heart. */
      var marked = card.closest('[' + MARK + ']');
      if (marked && marked !== card) return;

      var link = card.querySelector('a[href*="/products/"]');
      var handle = handleFrom(link && link.getAttribute('href'));
      if (!handle) return;

      card.setAttribute(MARK, '');

      var titleEl = card.querySelector('.product-title, .card__heading, h2, h3');
      var title = titleEl ? titleEl.textContent.trim().slice(0, 160) : '';

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'dvy-wl-btn dvy-wl-btn--floating dvy-wl-btn--injected';
      btn.setAttribute('data-dvy-wishlist-toggle', '');
      btn.setAttribute('data-wl-handle', handle);
      if (title) btn.setAttribute('data-wl-title', title);
      btn.setAttribute('aria-pressed', 'false');
      btn.setAttribute('aria-label', 'Save to wishlist');
      btn.innerHTML = HEART;

      /* Append to the CARD, never the media wrapper. Fabric owns the media
         wrapper and replaces it wholesale on hover; the card root is stable. */
      if (getComputedStyle(card).position === 'static') {
        card.style.position = 'relative';
      }
      card.appendChild(btn);
    });

    if (window.DvyWishlist) window.DvyWishlist.sync(root);
  }

  function boot() {
    try {
      inject(document);
    } catch (e) {
      console.error('[dvy-wishlist-inject]', e);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Fabric replaces DOM on filtering, pagination and section hydration
     without firing shopify:section:load. Watch removals too, in case a
     swap still takes one of our buttons with it. */
  if (typeof MutationObserver !== 'undefined') {
    var timer = null;

    new MutationObserver(function (records) {
      var hit = false;

      for (var i = 0; i < records.length && !hit; i++) {
        var r = records[i];

        for (var j = 0; j < r.addedNodes.length; j++) {
          var a = r.addedNodes[j];
          if (a.nodeType !== 1) continue;
          if (a.hasAttribute && a.hasAttribute('data-dvy-wishlist-toggle')) continue; // our own
          if (a.matches && a.matches('a[href*="/products/"]')) { hit = true; break; }
          if (a.querySelector && a.querySelector('a[href*="/products/"]')) { hit = true; break; }
        }
        if (hit) break;

        for (var k = 0; k < r.removedNodes.length; k++) {
          var d = r.removedNodes[k];
          if (d.nodeType !== 1) continue;
          if (d.matches && d.matches('[data-dvy-wishlist-toggle]')) { hit = true; break; }
          if (d.querySelector && d.querySelector('[data-dvy-wishlist-toggle]')) { hit = true; break; }
        }
      }

      if (!hit) return;
      clearTimeout(timer);
      timer = setTimeout(boot, 60);
    }).observe(document.body, { childList: true, subtree: true });
  }

  document.addEventListener('shopify:section:load', function (e) {
    inject(e.target);
  });

  window.DvyWishlistInject = inject;
})();